// src/components/attendanceService.js
import {
  collection,
  addDoc,
  query,
  where,
  getDocs,
  serverTimestamp
} from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { db } from "../firebase";

const attendanceCol = collection(db, "attendance");

export async function markAttendance(memberId, eventId, method = "manual") {
  // Ensure we know who is making the request
  const auth = getAuth();
  if (!auth.currentUser) {
    throw new Error("User not authenticated. Ensure anon sign-in has completed.");
  }

  // IMPORTANT: to satisfy rules, prefer memberId === auth.currentUser.uid
  // If caller passed a different memberId (trying to mark another member),
  // the write will be rejected unless that auth user is an admin.
  const payload = {
    memberId,                    // ideally equals auth.currentUser.uid
    eventId,
    method,
    actorId: auth.currentUser.uid, // keep track who performed the action (helpful for auditing)
    createdAt: serverTimestamp()
  };

  const ref = await addDoc(attendanceCol, payload);
  return { id: ref.id };
}

export async function getAttendanceForEvent(eventId) {
  if (!eventId) return [];
  const q = query(attendanceCol, where("eventId", "==", eventId));
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
}

export async function aiInferAttendance() {
  await new Promise(r => setTimeout(r, 10));
  return [
    { memberId: "ai-demo-1", confidence: 0.93, timestamp: Date.now() }
  ];
}
